import React from 'react';
import { Info, HandshakeIcon, BadgeCheck } from 'lucide-react';

const HowWeGetPaid = () => {
  return (
    <section id="how-we-get-paid" className="py-24 bg-gradient-to-b from-white via-emerald-50/50 to-white relative overflow-hidden">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-100 rounded-full opacity-20 blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-100 rounded-full opacity-20 blur-3xl translate-x-1/2 translate-y-1/2"></div>
      
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <Info size={16} />
            <span>Transparent & Honest</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How We Get Paid
          </h2>
        </div>

        {/* Main content card */}
        <div className="bg-white rounded-3xl shadow-xl border-2 border-emerald-100 p-8 md:p-12">
          <div className="space-y-8">
            {/* Main statement */}
            <div className="text-center pb-8 border-b border-gray-200">
              <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                Dolphin Power doesn't charge you a fee.
              </p>
            </div>

            {/* Explanation */}
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center">
                  <HandshakeIcon className="text-white" size={24} />
                </div>
                <div className="flex-grow">
                  <p className="text-lg text-gray-700 leading-relaxed">
                    When you choose a new energy contract through us, the supplier pays us a commission. This is <span className="font-semibold text-gray-900">usually built into the unit rate you're offered.</span>
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center">
                  <BadgeCheck className="text-white" size={24} />
                </div>
                <div className="flex-grow">
                  <p className="text-lg text-gray-700 leading-relaxed">
                    We'll always explain your options clearly, and you're <span className="font-semibold text-gray-900">never under any obligation to proceed.</span> If you'd like to understand how commission works on a particular contract, just ask and we'll talk it through.
                  </p>
                </div>
              </div>
            </div>

            {/* Trust badge */}
            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-6 mt-8 border border-emerald-200">
              <p className="text-center text-gray-700 leading-relaxed">
                <span className="font-semibold text-emerald-700">Our commitment:</span> Clear, simple, and supportive guidance without jargon or pressure. That's the Dolphin Power way.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeGetPaid;
